<router>
{
    name: 'infobak',
}
</router>
<template lang="pug">
v-container
    InfoBak
</template>
<script>

import InfoBak from '@/components/portal/infobak';

export default {
    meta: {
        // role: 'portalcontact'
    },
    components: {
        InfoBak
    },
    data () {
        return {

        };
    },
    methods: {

    },
    computed: {
    },
    mounted () {
        window.infobakvm = this;
    }
};
</script>

<style scoped>
</style>
